export default __webpack_public_path__ + "static/media/IconLineNotification.0d2d189c.svg";